/**
 * @license
 * @copyright Copyright Motili Inc., 2025 All Rights Reserved
 */

import { createAsyncThunk } from '@reduxjs/toolkit';
import { some } from 'lodash';
import {
    getContractorDashboardClient,
    getDashboardData,
} from 'common/services/AccountService';
import * as AuthService from 'common/services/AuthService';
import { getCronofyAccount } from 'common/services/ContractorSchedulerAvailabilityService';
import * as logger from 'common/utils/Logger';
import { disableDashboard } from 'common/stores/redux/FeaturesFlag';
import {
    DASHBOARD_SCOPE,
    DashboardClientResponse,
    DashboardSectionRequest,
    DashboardSectionResponse,
} from './types';

export interface fetchDashboardDataParamType {
    dashboard: DASHBOARD_SCOPE;
    sections: DashboardSectionRequest[];
    clientId?: string;
}

export const fetchDashboardData = createAsyncThunk<
    DashboardSectionResponse[],
    fetchDashboardDataParamType
>(
    'dashboard/fetchDashboardData',
    async ({ sections, clientId }, { dispatch }) => {
        const response = await getDashboardData(sections, clientId);

        const disabled = some(response, r => r?.result?.disabled);
        if (disabled) {
            dispatch(disableDashboard());
        }

        return response;
    }
);

export const fetchContractorDashboardClient = createAsyncThunk<
    DashboardClientResponse[]
>('dashboard/getContractorDashboardClient', async () => {
    return getContractorDashboardClient();
});

export const fetchContractorCalendar = createAsyncThunk(
    'dashboard/fetchContractorCalendar',
    async () => {
        const result = {
            enabled: false,
            synced: false,
        };
        const contractor = AuthService.getContractor();
        if (contractor?.ffScheduler) {
            result.enabled = true;
            try {
                const acct = await getCronofyAccount();
                if (acct) {
                    result.synced = true;
                }
            } catch (error) {
                logger.error(error);
            }
        }

        return result;
    }
);
